import React from 'react';
import PropTypes from 'prop-types';
import getCurrentLocale, { getLocaleLocation } from 'utilities/getCurrentLocale';
import { RowSet, FullRow, HalfRow } from './rowTypes';

const fieldsPropTypes = {
  fields: PropTypes.shape({
    label: PropTypes.node,
    address: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
    locality: PropTypes.node,
    region: PropTypes.node,
    postalCode: PropTypes.node,
    country: PropTypes.node
  })
};

const fieldsDefaultProps = {
  fields: {
    label: undefined,
    address: undefined,
    locality: undefined,
    region: undefined,
    postalCode: undefined,
    country: undefined
  }
};

export const UnitedStatesAddress = ({ fields }) => (
  <div className="address">
    <FullRow element={fields.label} className="address-label" />
    <RowSet value={fields.address} className="address" />
    <FullRow element={fields.locality} className="locality city" />
    <HalfRow elements={[fields.region, fields.postalCode]} className="region-postalCode state-zip" />
    <FullRow element={fields.country} className="country" />
  </div>
);

UnitedStatesAddress.propTypes = fieldsPropTypes;
UnitedStatesAddress.defaultProps = fieldsDefaultProps;

const AddressLayout = ({ locale, ...fields }) => {
  const location = getLocaleLocation(locale).toLowerCase();
  switch (location) {
    default:
    case 'us': {
      return <UnitedStatesAddress fields={fields} />;
    }
  }
};

AddressLayout.propTypes = {
  locale: PropTypes.string,
  ...fieldsPropTypes
};

AddressLayout.defaultProps = {
  locale: getCurrentLocale(),
  ...fieldsDefaultProps
};

export default AddressLayout;
